export interface ITransplantsLast12Months {
    centerId: number,
    centerAlias: string,
    txpCount: number,
    rank: number,
    category: string
}